"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactFulcrum = require("@upgrowth/react-fulcrum");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var revertValue = function revertValue(onChange, path, current, confirm) {
  if (confirm !== 'ask' || window.confirm("Are you sure you want to discard all changes since last publish?")) {
    onChange(path, current, true);
  }
};

var publishValue = function publishValue(onChange, path, value, confirm) {
  if (confirm !== 'ask' || window.confirm("Are you sure you want to publish?")) {
    onChange(path, value, true);
  }
};

var deleteValue = function deleteValue(onDelete, path, confirm) {
  if (confirm === 'silent' || window.confirm("Are you sure you want to delete? You cannot revert this change")) {
    onDelete(path, true);
  }
};

var PublishActions = function PublishActions(_ref) {
  var type = _ref.type,
      context = _ref.context,
      children = _ref.children;
  var onChange = context.onChange,
      onDelete = context.onDelete,
      path = context.path,
      isClean = context.isClean,
      value = context.value,
      current = context.current;
  var _type$publishable = type.publishable,
      publishable = _type$publishable === undefined ? false : _type$publishable,
      _type$deletable = type.deletable,
      deletable = _type$deletable === undefined ? false : _type$deletable;
  var open = publishable && !isClean || deletable;

  if (publishable || deletable) {
    return _react2.default.createElement("div", {
      className: "PublishActions"
    }, _react2.default.createElement("div", {
      className: "actions " + (open ? 'open' : 'closed')
    }, deletable && _react2.default.createElement(_reactFulcrum.Button, {
      onClick: function onClick() {
        return deleteValue(onDelete, path, deletable);
      },
      variant: "secondary"
    }, "Delete"), _react2.default.createElement(_reactFulcrum.Flex, null), publishable && _react2.default.createElement(_reactFulcrum.Button, {
      onClick: function onClick() {
        return revertValue(onChange, path, current, publishable);
      },
      disabled: isClean,
      variant: "secondary"
    }, "Revert"), publishable && _react2.default.createElement(_reactFulcrum.Button, {
      disabled: isClean,
      onClick: function onClick() {
        return publishValue(onChange, path, value, publishable);
      }
    }, "Publish")), children);
  } else {
    return children;
  }
};

exports.default = PublishActions;